import React from "react";
import { NavLink } from "react-router-dom";

// React Bootstrap
import Nav from "react-bootstrap/Nav";

const SignedOutLinks = () => {
  return (
    <Nav>
      <Nav.Link className="topbar-link" href="/signup">
        サインアップ
      </Nav.Link>
      <Nav.Link className="topbar-link" href="/login">ログイン</Nav.Link>
    </Nav>
  );
};

export default SignedOutLinks;
